export class besoinsLogementSociaux {
    constructor() {}
    nbDemandeRapportAttribution: any = {
        PA: null,
    };
    mutation: any = {
        PA: null,
    };
    nombreLogementLivre: any = {
        PA: null,
    };
    tauxCroissance: any = {
        PA: null,
    };
    besoinsLogementSociaux: any = {
        PA: null,
    };
    lgtSociauxVacants: any = {
        PA: null,
    };
}

export class caracteristiqueHlm {
    constructor() {}
    lgtNeuf2013: any = {
        ON: null,
    };
    lgtNeuf2014: any = {
        ON: null,
    };
    lgtNeuf2015: any = {
        ON: null,
    };
    nombre: any = {
        AT: null,
        ATRPLS: null,
        DE: null,
        ON: null,
        PA: null,
    };
    nombreHorsQPV: any = {
        AT: null,
        ATRPLS: null,
        ON: null,
        PA: null,
    };
    nombreNsp: any = {
        AT: null,
        ATRPLS: null,
    };
    nombreQPV: any = {
        AT: null,
        ATRPLS: null,
        ON: null,
        PA: null,
    };
    T1: any = {
        AT: null,
        ATRPLS: null,
        DE: null,
        ON: null,
        PA: null,
    };
    T2: any = {
        AT: null,
        ATRPLS: null,
        DE: null,
        ON: null,
        PA: null,
    };
    T3: any = {
        AT: null,
        ATRPLS: null,
        DE: null,
        ON: null,
        PA: null,
    };
    T4: any = {
        AT: null,
        ATRPLS: null,
        DE: null,
        ON: null,
        PA: null,
    };
    T5Plus: any = {
        AT: null,
        ATRPLS: null,
        DE: null,
        ON: null,
        PA: null,
    };
    T1T2: any = {
        AT: null,
        ATRPLS: null,
        DE: null,
        ON: null,
        PA: null,
    };
    T4T5Plus: any = {
        AT: null,
        ATRPLS: null,
        DE: null,
        ON: null,
        PA: null,
    };
}
export class caracteristiqueSocioDemographique {
    constructor() {}
    actif: any = {
        PA: null,
    };
    chomeur: any = {
        PA: null,
    };
    croissanceDemo: any = {
        PA: null,
    };
    pauvrete: any = {
        PA: null,
    };
    RUC2eDecile: any = {
        PA: null,
    };
}

export class caracteristiqueSociologique {
    constructor() {}
    autreMenage: any = {
        AT: null,
        PA: null,
    };
    couple: any = {
        AT: null,
        DE: null,
        PA: null,
    };
    enmennageRecent: any = {
        AT: null,
    };

    enmennageRecentHorsQPV: any = {
        AT: null,
    };

    enmennageRecentQPV: any = {
        AT: null,
    };

    entrePLAIEtPLUS: any = {
        AT: null,
    };

    entrePLUSEtPLS: any = {
        AT: null,
    };

    inf20PcentPlafondPLUS: any = {
        AT: null,
        PA: null,
    };
    inf20PcentPlafondPLUSHorsQPV: any = {
        AT: null,
        PA: null,
    };

    inf20PcentPlafondPLUSQPV: any = {
        AT: null,
        PA: null,
    };

    inf30ans: any = {
        AT: null,
        DE: null,
        PA: null,
    };

    inf40PcentPlafondPLUS: any = {
        AT: null,
        PA: null,
    };

    inf40PcentPlafondPLUSHorsQPV: any = {
        AT: null,
        PA: null,
    };

    inf40PcentPlafondPLUSQPV: any = {
        AT: null,
        PA: null,
    };

    inf60PcentPlafondPLUS: any = {
        AT: null,
        PA: null,
    };

    inf60PcentPlafondPLUSHorsQPV: any = {
        AT: null,
        PA: null,
    };
    inf60PcentPlafondPLUSQPV: any = {
        AT: null,
        PA: null,
    };

    infPlafond60PcentPlafondPLUSHorsQPV: any = {
        PA: null,
    };
    infPlafondPLAI: any = {
        AT: null,
    };
    isole: any = {
        AT: null,
        DE: null,
        PA: null,
    };

    monoparental: any = {
        AT: null,
        DE: null,
        PA: null,
    };

    nonSaisie: any = {
        AT: null,
    };
    pourcentagePremierQuartile: any = {
        AT: null,
    };
    pourcentagePremierQuartileHorsQPV: any = {
        AT: null,
    };
    pourcentagePremierQuartileQPV: any = {
        AT: null,
    };
    reponseOPS: any = {
        PA: null,
    };
    reponseOPSHorsQPV: any = {
        PA: null,
    };
    reponseOPSQPV: any = {
        PA: null,
    };
    sup65ans: any = {
        AT: null,
        DE: null,
        PA: null,
    };

    supPLS: any = {
        AT: null,
    };
    total: any = {
        AT: null,
    };
    APL: any = {
        PA: null,
        AT: null,
    };
}

export class dynamisme {
    constructor() {}
    construNeuve: any = {
        PA: null,
    };
    construNeuvePourMille: any = {
        PA: null,
    };
    loyerLgtSociaux: any = {
        PA: null,
    };
    loyerMarche: any = {
        PA: null,
    };
    vacancePrive: any = {
        PA: null,
    };
}

export class financement {
    constructor() {}
    nonReserve: any = {
        AT: null,
        ON: null,
        PA: null,
    };

    PLAI: any = {
        AT: null,
        ON: null,
        PA: null,
    };

    PLI: any = {
        AT: null,
        ON: null,
        PA: null,
    };

    PLS: any = {
        AT: null,
        ON: null,
        PA: null,
    };

    PLUS: any = {
        AT: null,
        ON: null,
        PA: null,
    };
}
export class localisation {
    constructor() {
        this.codeCommune = null;
        this.codeDepartement = null;
        this.codeINSEE = null;
        this.commune = null;
        this.communeSNE = null;
        this.departement = null;
        this.epci = null;
    }
    codeCommune: string | null;
    codeDepartement: string | null;
    codeINSEE: string | null;
    commune: string | null;
    communeSNE: string | null;
    departement: string | null;
    epci: string | null;

    habitant: any = {
        PA: null,
        PA2012: null,
    };
    resiPrincipale: any = {
        PA: null,
    };

    tableRegion: any = {
        nom: "",
        nbHabitant: "",
        resiPrinciaple: "",
    };
    tableDepartement: any = {
        nom: "",
        nbHabitant: "",
        nbHabitantRatio: "",
        resiPrinciaple: "",
        resiPrinciapleRatio: "",
    };
    tableEpci: any = {
        nom: "",
        nbHabitant: "",
        nbHabitantRatio: "",
        resiPrinciaple: "",
        resiPrinciapleRatio: "",
    };
    tableCommune: any = {
        nom: "",
        nbHabitant: "",
        nbHabitantRatio: "",
        resiPrinciaple: "",
        resiPrinciapleRatio: "",
    };
}

export class loyersLogementPLUSPLAI {
    compage: any = {
        PA: null,
    };
    ecartPlafond: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    lgtAbordableHorsQPV: any = {
        AT: null,
        ON: null,
        PA: null,
    };

    lgtAbordableQPV: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    lgtAbordableTotal: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    lgtPLUSPLAI: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    lgtPLUSPLAIHorsQPV: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    lgtPLUSPLAIQPV: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerInf3: any = {
        PA: null,
    };
    loyerNonVideEnQPV: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerNonVideHorsQPV: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerNonVideTot: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPLUSPLAIHorsQPV: any = {
        ON: null,
        PA: null,
    };
    loyerPLUSPLAIQPV: any = {
        ON: null,
        PA: null,
    };
    loyerPLUSPLAITotal: any = {
        ON: null,
        PA: null,
    };
    loyerPratique: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueEntre35et4: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueEntre3et35: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueEntre45et5: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueEntre4et45: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueEntre55et6: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueEntre5et55: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueEntre65et7: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueEntre6et65: any = {
        AT: null,
        ON: null,
        PA: null,
    };

    // Ajout pour le calcul ulterieur
    loyerPratiqueInf4: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueEntre4et5: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueEntre5et6: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueEntre6et7: any = {
        AT: null,
        ON: null,
        PA: null,
    };

    loyerPratiqueHorsQPV: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueInf3: any = {
        ON: null,
        PA: null,
    };
    loyerPratiqueInf55QPV: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueInf55HorsQPV: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueInf55: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueQPV: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyerPratiqueSup7: any = {
        AT: null,
        ON: null,
        PA: null,
    };
    loyMoyPLAIneuf: any = {
        PA: null,
    };
    loyPlafZoneAPL: any = {
        PA: null,
    };
    RUC2eDecile: any = {
        PA: null,
    };
    zoneAPL: any = {
        PA: null,
    };
}

export class parcSocial {
    bailleur: any = {
        PA: null,
    };
    bailleurSup50: any = {
        PA: null,
    };
    lgtSociaux: any = {
        PA: null,
    };

    lgtSociauxBis: any = {
        PA: null,
    };

    logementSociaux: any = {
        PA: null,
    };
    logementSociauxTaux: any = {
        PA: null,
    };
    logementSociauxQPV: any = {
        PA: null,
    };
    logementSociauxQPVTaux: any = {
        PA: null,
    };
    revenuPremierQuartile: any = {
        PA: null,
    };
}

export class repartitionPatrimoine {
    lgt2000: any = {
        PA: null,
    };
    lgt2000EFG: any = {
        PA: null,
    };
    lgt2000EFGpcent: any;

    lgt60A69: any = {
        PA: null,
    };
    lgt60A69EFG: any = {
        PA: null,
    };
    lgt60A69EFGpcent: any;

    lgt70A79: any = {
        PA: null,
    };
    lgt70A79EFG: any = {
        PA: null,
    };
    lgt70A79EFGpcent: any;

    lgt80A89: any = {
        PA: null,
    };
    lgt80A89EFG: any = {
        PA: null,
    };
    lgt80A89EFGpcent: any;

    lgt90A99: any = {
        PA: null,
    };
    lgt90A99EFG: any = {
        PA: null,
    };
    lgt90A99EFGpcent: any;

    lgtAvant1960: any = {
        PA: null,
    };
    lgtAvant1960EFG: any = {
        PA: null,
    };
    lgtAvant1960EFGpcent: any;

    moyenne: any = {
        PA: null,
    };
    moyenneEFG: any = {
        PA: null,
    };
    moyenneEFGpcent: any;
}

export class caracteristiqueBailleur {
    nombre: any = {
        PA: null,
        NB: null,
        tauxPartMarche: null,
    };
    offreNouvelleMoyenneAn: any = {
        PA: null,
        NB: null,
        tauxPartMarche: null,
    };
    offreNouvelle2015: any = {
        PA: null,
        NB: null,
    };
    offreNouvelle2014: any = {
        PA: null,
        NB: null,
    };
    offreNouvelle2013: any = {
        PA: null,
        NB: null,
    };
    tauxCroissance: any = {
        PA: null,
        NB: null,
    };
    mutationAttribution: any = {
        PA: null,
        NB: null,
    };
}



// WEBPACK FOOTER //
// ./resources/assets/js/InterfaceTerritoire.ts